import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MultiLingualContent from "../languages/MultiLingualContent";
import decorative from "../assets/decoratives/2.png";
import logo from "../assets/images/logo2.jpg";
import sign from "../assets/decoratives/sign.png";
import serum from "../assets/images/serum.jpeg";
import krishit from "../assets/images/krishit15.jpeg";

const About = () => {
  return (
    <div className="section" id="about">
      <div className="about-wrapper inner-section">
        <h2>
          <MultiLingualContent contentID="about" />
        </h2>
        <p>
          <MultiLingualContent contentID="aboutText1" />
        </p>
        <br />
        <p>
          <MultiLingualContent contentID="aboutText2" />
        </p>
        <br />
        <p>
          <MultiLingualContent contentID="aboutText3" />
        </p>
        <br />
        <p>
          <MultiLingualContent contentID="aboutText4" />
        </p>
        <br />
        <h3 className="whatsInSite">
          <MultiLingualContent contentID="aboutWhatsInSite" />
        </h3>
        <p>
          <MultiLingualContent contentID="aboutWhatsInSiteBullet1" />
        </p>
        <p>
          <MultiLingualContent contentID="aboutWhatsInSiteBullet2" />
        </p>
        <p>
          <MultiLingualContent contentID="aboutWhatsInSiteBullet3" />
        </p>
        <p>
          <MultiLingualContent contentID="aboutWhatsInSiteBullet4" />
        </p>
        <p>
          <MultiLingualContent contentID="aboutWhatsInSiteBullet5" />
        </p>
        <p>
          <MultiLingualContent contentID="aboutWhatsInSiteBullet6" />
        </p>
        <p>
          <MultiLingualContent contentID="aboutWhatsInSiteBullet7" />
        </p>
        <br />
        <p>
          <MultiLingualContent contentID="aboutWhatsInSiteBullet8" />
        </p>
        <br />
        <div className="news">
          <h3 className="whatsInSite">
            <MultiLingualContent contentID="news" />
          </h3>
          <div className="news-text">
            <h4>פטריות בעולם היופי</h4>
            <p>
              נושא פטריות מרפא מפותח שנים רבות בשימוש פנימי, כלומר– שתיית תמציות
              ובליעת כמוסות. בתקופתנו מתעצם טיפול חיצוני בתחום הקוסמטיקה לטיפוח
              העור, הידוע בסין כבר מאות שנים. מ 2005 החל דר' אנדרו וייל, החי
              בארה''ב, לחקור מדעית ולשלב ברפואה הטבעית מיני פטריות במשחות,
              מסכות, שמפו וסרומים. הם משפיעים על הרגעת העור, אנטי דלקתיות, תוספת
              לחות עמוקה, ריכוך, זוהר ומניעת הזדקנות.
            </p>
            <br />
            <p>
              הסוגים העיקריים בתעשייה הם – טרמלה, בכינוי – 'פטריית היופי', בעלת
              תכונות רפואיות מגוונות. כמו כן הסוג בהוקית - בכינוי ריישי, והסוג
              קורדיספס. החומרים מהפטרייה, המהווים חלק מהמעטפת התאית, מכילים
              פוליסכרידים ממינים שונים בעלי תפקיד משמעותי בתפקוד מערכות
              לבריאותנו. הבולט והחשוב לטיפוח היופי הוא בטא-גלוקן התומך ביצירת
              קולגן. חומצה סליצילית וקוג'ית גורמות להבהרת העור.
            </p>
            <br />
            <p>בישראל הייצור והשימוש עדיין בחיתוליו.</p>
            <div className="aboutImgTextWrapper">
              <div className="aboutImgWrapper">
                <LazyLoadImage
                  src={serum}
                  alt="מיצוי פטרייה"
                  className="smallImg"
                />
              </div>
              <div className="aboutImgWrapper">
                <LazyLoadImage
                  src={krishit}
                  alt="מיצוי פטרייה"
                  className="smallImg"
                />
              </div>
            </div>
          </div>
          <LazyLoadImage src={sign} alt="" className="sign-img" />
        </div>
        <br />
        <h3 className="whatsInSite">
          <MultiLingualContent contentID="thanks" />
        </h3>
        <p>
          <MultiLingualContent contentID="thanksText1" />
        </p>
        <p>
          <MultiLingualContent contentID="thanksText2" />
        </p>
        <p>
          <MultiLingualContent contentID="thanksText3" />
        </p>
        <p>
          <MultiLingualContent contentID="thanksText4" />
        </p>
        <p>
          <MultiLingualContent contentID="thanksText5" />
        </p>
        <p>
          <MultiLingualContent contentID="thanksText6" />
        </p>
        <p>
          <MultiLingualContent contentID="thanksText7" />
        </p>
        <br />
        <LazyLoadImage src={logo} alt="logo" className="logoPng" />
        <br />
        <p>
          <MultiLingualContent contentID="aboutFinalText" />
        </p>
        <br />
      </div>
      <LazyLoadImage src={decorative} alt="" className="decorative-about" />
    </div>
  );
};

export default About;
